import { Box } from "@mui/material";
import React from "react";

const DetailCard = ({ children, style }) => {
  return (
    <Box
      sx={{
        // bgcolor: "red",
        bgcolor: "#FAFAFA",
        p: 3,
        borderRadius: "7px",
        mb: 3,
        ...style,
      }}
    >
      {children}
    </Box>
  );
};

export default DetailCard;
